import { Typography } from "@material-ui/core";

export default function BlockHeader({ block }) {
  return (
    <Typography variant="h2" gutterBottom>
      {block.text.text}
    </Typography>
  );
}
